import React from 'react';
import './CampaignEditorSidebar.css';

function CampaignEditorSidebar({ activeSection, onSectionChange }) {
  const sections = [
    { id: 'overview', label: 'Overview', icon: '📋' },
    { id: 'story', label: 'Story', icon: '📖' },
    { id: 'sessions', label: 'Sessions', icon: '🎲' },
    { id: 'players', label: 'Players', icon: '👥' },
    { id: 'npcs', label: 'NPCs', icon: '🎭' },
    { id: 'maps', label: 'Maps', icon: '🗺️' }
  ];

  return (
    <div className="campaign-editor-sidebar">
      <div className="sidebar-header">
        <h3>Campaign Tools</h3>
      </div>
      
      <nav className="sidebar-nav">
        {sections.map(section => (
          <button
            key={section.id}
            className={`sidebar-nav-item ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => onSectionChange(section.id)}
          >
            <span className="nav-icon">{section.icon}</span>
            <span className="nav-label">{section.label}</span>
          </button>
        ))}
      </nav>
    </div>
  );
}

export default CampaignEditorSidebar;
